<template>
  <report-section title="用户信息" style="position: relative">
    <template v-slot:title-right>
      <edit-button style="position: absolute; right: 0" :inputIsEditable="isEditable" :disabled="isPreviewMode"
        @onEdit="onEdit" @onSave="onSave"></edit-button>
    </template>
    <template v-slot:content>
      <div class="section-user-info" style="width: 100%; padding-right: 90px;">
        <div v-if="isEditable" class="section-user-info-editable">
          <!-- 第一行：姓名、性别、年龄、出生日期、身高 -->
          <div class="section-user-info-editable-item">
            <key-unit-input title="姓名" v-model="name"></key-unit-input>
            <key-unit-input title="性别" v-model="gender"></key-unit-input>
            <key-unit-input title="年龄" v-model="age"></key-unit-input>
            <!-- <key-unit-date-picker title="出生日期" v-model="birthday" :picker-options="pickerOptions"/> -->
            <key-unit-input title="身高" v-model="height"></key-unit-input>

          </div>
          <!-- 第二行：体重、BMI、病案号、单位 -->
          <div class="section-user-info-editable-item section-user-info-editable-item-last">
            <key-unit-input title="体重" v-model="weight"></key-unit-input>
            <key-unit-input title="BMI" v-model="bmi" :disabled="true"></key-unit-input>
            <key-unit-input title="病案号" v-model="medicalRecordNumber"></key-unit-input>
            <key-unit-input title="颈围" v-model="neckCircumference"></key-unit-input>
            <!-- <key-unit-input title="单位" v-model="unit"></key-unit-input> -->
          </div>
          <!-- 第三行：手机号、颈围、腰围、腹围、臀围 -->
          <div class="section-user-info-editable-item section-user-info-editable-item-last">
            <!-- <key-unit-input title="手机号" v-model="mobile"></key-unit-input> -->
            
            <key-unit-input title="腰围" v-model="chestCircumference"></key-unit-input>
            <!-- <key-unit-input title="腹围" v-model="waistCircumference"></key-unit-input> -->
            <key-unit-input title="臀围" v-model="hipCircumference"></key-unit-input>
          </div>
        </div>
        <div v-else class="section-user-info-not-editable">
          <!-- 第一行：姓名、性别、年龄、出生日期、身高 -->
          <div class="user-info-row">
            <div class="user-info-item">
              <span class="label">姓名：</span>
              <span class="value">{{ reportDetailModel.nameStr }}</span>
            </div>
            <div class="user-info-item">
              <span class="label">性别：</span>
              <span class="value">{{ reportDetailModel.genderStr }}</span>
            </div>
            <div class="user-info-item">
              <span class="label">年龄：</span>
              <span class="value">{{ reportDetailModel.ageStr }}</span>
            </div>
           
            <div class="user-info-item">
              <span class="label">身高：</span>
              <span class="value">{{ reportDetailModel.heightStr }}</span>
            </div>
            <div class="user-info-item">
              <span class="label">体重：</span>
              <span class="value">{{ reportDetailModel.weightStr }}</span>
            </div>
            <div class="user-info-item">
              <span class="label">BMI：</span>
              <span class="value">{{ reportDetailModel.bmiStr }}</span>
            </div>
          </div>

          <!-- 第二行：体重、BMI、病案号、单位 -->
          <div class="user-info-row">
            <div class="user-info-item">
              <span class="label">手机号：</span>
              <span class="value">{{ reportDetailModel.mobileStr }}</span>
            </div>
            <div class="user-info-item">
              <span class="label">病案号：</span>
              <span class="value">{{ reportDetailModel.medicalRecordNumber }}</span>
            </div>
            <!-- <div class="user-info-item">
              <span class="label">单位：</span>
              <span class="value">{{ reportDetailModel.unitStr }}</span>
            </div> -->
          </div>

          <!-- 第三行：手机号、颈围、腰围、腹围、臀围 -->
          <div class="user-info-row">

            <div class="user-info-item">
              <span class="label">颈围：</span>
              <span class="value">{{ reportDetailModel.neckCircumferenceStr }}</span>
            </div>
            <div class="user-info-item">
              <span class="label">腰围：</span>
              <span class="value">{{ reportDetailModel.chestCircumferenceStr }}</span>
            </div>
            <!-- <div class="user-info-item">
              <span class="label">腹围：</span>
              <span class="value">{{ reportDetailModel.waistCircumferenceStr }}</span>
            </div> -->
            <div class="user-info-item">
              <span class="label">臀围：</span>
              <span class="value">{{ reportDetailModel.hipCircumferenceStr }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="custom-divider-mt0"></div>
    </template>
  </report-section>
</template>

<script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
import EditButton from "@c/report-detail/single-blood-oxygen-report/common/edit-button.vue";
import KeyValueUnit from "@c/report-detail/single-blood-oxygen-report/common/new-key-value-unit/key-value-unit-blood-oxygen-report.vue";
import KeyUnitInput from "@c/report-detail/single-blood-oxygen-report/common/new-key-unit/key-unit-input.vue";
import { computeBMI } from "@js/common-tool.js";
import KeyUnitDatePicker from "@c/report-detail/single-blood-oxygen-report/common/new-key-unit/key-unit-date-picker.vue";
import dayjs from "dayjs";
export default {
  components: {
    ReportSection,
    EditButton,
    KeyValueUnit,
    KeyUnitInput,
    KeyUnitDatePicker,
  },

  props: {
    reportDetailModel: Object,
    isPreviewMode: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isEditable: false,
      name: undefined,
      gender: undefined,
      age: undefined,
      birthday: undefined,
      height: undefined,
      weight: undefined,
      bmi: undefined,
      medicalRecordNumber: undefined,
      unit: undefined,
      mobile: undefined,
      neckCircumference: undefined,
      waistCircumference: undefined,
      chestCircumference: undefined,
      hipCircumference: undefined,
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
    };
  },

  computed: {
    // 现在所有三行都会显示，移除条件判断
  },

  created() {
    this.setupUserInfo();
  },

  watch: {
    reportDetailModel() {
      this.setupUserInfo();
    },

    height() {
      this.computeBMI();
    },

    weight() {
      this.computeBMI();
    },
  },

  methods: {
    onEdit() {
      this.isEditable = true;
      this.setupUserInfo(); // 重新设置用户信息
    },

    async onSave() {
      try {
        //名字input上已做限制
        this.validateGender();
        // this.validateBirthday();
        this.validateValue(this.height, "身高");
        this.validateValue(this.weight, "体重");
        this.saveUserInfo();
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async saveUserInfo() {
      const bmi = computeBMI(this.height, this.weight, 1);
      
      
      const params = {
        reportNumber: this.$router.history.current.query.reportURL,
        age: this.age,
        trueName: this.name,
        sex: this.gender, 
        height: this.height,
        weight: this.weight,
        bmi: bmi,
        mzh: this.medicalRecordNumber,
        mobile: this.mobile,
        neckCircumference: this.neckCircumference,
        waistCircumference: this.waistCircumference,
        chestCircumference: this.chestCircumference,
        hipCircumference: this.hipCircumference,
      };
      try {
        await this.$api.editReportDetail(params);
        this.isEditable = false;
        this.$emit("onEditUserInfoSucceed");
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    setupUserInfo() {
      if (!this.reportDetailModel) return;

      // 优先从reportUser获取数据，如果没有则从reportDetailModel直接获取
      const user = this.reportDetailModel.reportUser || {};
      
      this.name = user.name || this.reportDetailModel.nameStr;
      this.age = user.age || this.reportDetailModel.ageStr;
      
      // 性别处理：直接使用字符串，不进行数字转换
      if (user.sex) {
        // 如果sex是数字，转换为字符串
        if (user.sex === 1 || user.sex === '1') {
          this.gender = '男';
        } else if (user.sex === 2 || user.sex === '2') {
          this.gender = '女';
        } else {
          this.gender = user.sex; // 已经是字符串
        }
      } else {
        this.gender = this.reportDetailModel.genderStr || "";
      }
      
      // 身高体重：去掉单位后缀
      this.height = user.height || this.extractNumber(this.reportDetailModel.heightStr);
      this.weight = user.weight || this.extractNumber(this.reportDetailModel.weightStr);
      this.bmi = this.extractNumber(this.reportDetailModel.bmiStr);
      
      this.medicalRecordNumber = user.medicalRecordNumber || this.reportDetailModel.medicalRecordNumber;
      this.unit = this.reportDetailModel.unitStr;
      this.mobile = user.mobile || this.reportDetailModel.mobileStr || "";
      this.neckCircumference = user.neckCircumference || this.extractNumber(this.reportDetailModel.neckCircumferenceStr) || "";
      this.waistCircumference = user.waistCircumference || this.extractNumber(this.reportDetailModel.waistCircumferenceStr) || "";
      this.chestCircumference = user.chestCircumference || this.extractNumber(this.reportDetailModel.chestCircumferenceStr) || "";
      this.hipCircumference = user.hipCircumference || this.extractNumber(this.reportDetailModel.hipCircumferenceStr) || "";
      this.birthday = user.birthday;
    },

    // 从带单位的字符串中提取数字值
    extractNumber(str) {
      if (!str || str === '') return '';
      // 匹配数字部分（包括小数）
      const match = str.toString().match(/\d+(\.\d+)?/);
      return match ? match[0] : '';
    },

    validateGender() {
      try {
        //为空不做判断
        if (this.gender == "") {
          return;
        }
        if (this.gender != "男" && this.gender != "女") {
          throw "";
        }
      } catch (error) {
        throw "性别只能填男或女";
      }
    },

    validateBirthday() {
      try {
        //为空不做判断
        if (!this.birthday) {
          throw "生日不能为空";
        }
        //判断日期格式
        if (!dayjs(this.birthday).isValid()) {
          throw "日期格式错误";
        }
      } catch (error) {
        throw error;
      }
    },

    validateAge() {
      try {
        //为空不做判断
        if (this.age == "") {
          return;
        }
        //判断整数
        if (this.age.indexOf(".") != -1) {
          throw "不是整数";
        }
        //判断[0,200]
        const ageNumber = Number(this.age);
        if (isNaN(ageNumber)) {
          throw "不是数字";
        }
        if (0 < ageNumber && ageNumber > 200) {
          throw "不属于0-200";
        }
      } catch (error) {
        throw "患者年龄是0-200的整数";
      }
    },

    validateValue(value, name) {
      try {
        //为空不做判断
        if (value == "") {
          return;
        }
        //判断最多一位小数
        if (value.split(".")[1] && value.split(".")[1].length > 1) {
          throw "最多一位小数";
        }
        //判断[0,300]
        const valueNumber = Number(value);
        if (isNaN(valueNumber) || 0 > valueNumber || valueNumber > 300) {
          throw "应为0-300";
        }
      } catch (error) {
        throw `患者${name}${error}`;
      }
    },

    // BMI自动计算
    computeBMI() {
      if (this.height && this.weight) {
        this.bmi = computeBMI(this.height, this.weight, 1);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/.section-user-info {
  display: flex;
  width: 100%;

  .key-unit-input {
    width: 120px; // 调整宽度以适应5个字段
    margin-top: 20px;
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  &-not-editable {
    width: 100%;
    display: flex;
    flex-direction: column;

    .user-info-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;

      // 所有行都使用五等分布局
      .user-info-item {
        flex: 1;
        margin-right: 15px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .user-info-item {
      display: flex;
      align-items: center;

      .label {
        font-size: 16px;
        color: #000;
        font-weight: normal;
        margin-right: 4px;
        // font-weight: 600;
      }

      .value {
        font-size: 16px;
        color: #000;
        font-weight: normal;
      }
    }
  }

  &-editable {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    &-item {
      display: flex;
      align-items: center;

      &-last {
        margin-top: 20px;
      }
    }

    .key-unit {
      margin-right: 20px;
    }
  }
}
</style>

